var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('oil-form',{attrs:{"title":_vm.title.toUpperCase(),"createForm":!_vm.id,"keys":_vm.keys,"items":_vm.vehicle,"formCallback":_vm.formCallback}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }